import { createDynamicThunk } from ".";
export const fileUploadThunk = createDynamicThunk({
  typePrefix: "fileUpload/upload",
  endpoint: "/data/import",
  method: "POST",
});
